export const fontWeightTheme = {
  normal: 400,
  medium: 500,
  bold: 700
};